import React, { useState } from 'react';


function HelpWindow(props) {
    const [show, setShow] = useState(false);

    // position: absolute;
    // top: 0;
    // bottom: 0;
    // left: 0;
    // right: 0;
    // margin: auto;
    // width: 100px;
    // height: 100px;
    // background - color: blue;
    const window = (
        <div>
            <div className="fullscreen transparent" onClick={
                () => setShow(() => false)
            } />
            <div className="help-window">
                <div>
                    <h3>
                        What you can see:
                    </h3>
                    <p>
                        On the left side is a 3D drawing of your scene. On the right is a top down view.
                        That is also where you change and create elements.
                     </p>

                    <h3>
                        General controls:
                    </h3>
                    <p>
                        You can move around the 3D scene by dragging the mouse on it to change your viewing direction.
                        WASD is used for movement in your viewplane. 'q' and 'e' lets you move up and down.
                        Alternatively, you can use the Camera tool to enter specific values.
                    </p>
                    <p>
                        In the edit view, you can drag the screen via clicking and dragging the middle mouse button.
                        If you move your mouse to the borders of the view, it will also move in that direction. 
                        Helpful, if you want to create objects bigger than the current viewport.
                        You can zoom with the Viewport settings on the right and also with your mousewheel.
                    </p>
                    <h3>
                        Select Tool:
                    </h3>
                    <p>
                        Allows you to select objects. Their properties are displayed below the view.
                        If no object is selected, you can also delete them all.
                    </p>
                    <p>
                        You can set various properties and delete the object there. If there are multiple overlapping objects where you click,
                        the topmost or newest will be selected first.
                        To select the other objects, keep clicking and it will cycle through them.
                        You can deselect objects by clicking on empty space.
                    </p>
                    <p>
                        When an object is selected, a small circle appears at its center.
                        You can move the object around by dragging  that circle.
            	    </p>
                    <h3>
                        Move Viewport Tool:
                    </h3>
                    <p>
                        Allows you to move the view inside of the edit window. Drag on empty space to move around.
                        The current camera position is displayed as a yellow circle.
                    </p>
                    <h3>
                        Camera Tool:
                    </h3>
                    <p>
                        Allows you to see and change the position and orientation of the camera. You can also reset the values.
                        You can set the field of view.
                    </p>
                    <h3>
                        Points Tool
                    </h3>
                    <p>
                        Allows you to create objects by placing the outer points on the edit window by clicking.
                        With activated snapping, the points will always lie on the displayed grid.
                        You can see the length of each line displayed in the middle of that line.
                        You can close an object by clicking either on the first or last point.
                        If you click on the first point, a polygon is created.
                        Clicking on the last will create a line strip.
                     </p>
                    <h3>
                        Rectangle Tool
                    </h3>
                    <p>
                        Allows you to create rectangles.
                        With activated snapping, the points will always lie on the displayed grid.
                        A rectangle is created by pressing the left mouse button and then moving the mouse to the desired location.
                        Letting go of the button will create the rectangle. No rectangle will be created, if any side has a length of zero.
                    </p>
                    <h3>
                        Freehand Tool
                    </h3>
                    <p>
                        Allows you to freely draw a polygon.
                        The result will be simplified a bit to avoid unnessecarry clutter.
                    </p>
                    <h3>
                        Load/Save Tool
                    </h3>
                    <p>
                        Here you can load and save your current scene.
                        This will save all objects and their properties as well as your current camera position and orientation
                    </p>
                </div>
                <button onClick={() => setShow(false)}>Close</button>
            </div>
        </div>
    );

    return (
        <div>
            <button onClick={() => setShow(true)}>Show Help</button>
            {show ? window : null}
        </div>
    );

}


export {
    HelpWindow
}